import { Box, Button, Checkbox, CloseButton, Dialog, Portal, Text } from '@chakra-ui/react'

type Props = {
  open: boolean
  confirmed: boolean
  onConfirmedChange: (v: boolean) => void
  onCancel: () => void
  onContinueSave: () => void
  onContinueSaveAndNew?: () => void
}

export default function TojPlausibilityDialog({
  open,
  confirmed,
  onConfirmedChange,
  onCancel,
  onContinueSave,
  onContinueSaveAndNew,
}: Props) {
  return (
    <Dialog.Root open={open} onOpenChange={({ open }) => (!open ? onCancel() : null)}>
      <Portal>
        <Dialog.Backdrop />

        <Dialog.Positioner>
          <Dialog.Content maxW="sm">
            <Dialog.CloseTrigger asChild>
              <CloseButton />
            </Dialog.CloseTrigger>
            <Dialog.Header>
              <Dialog.Title>Erfasste TOJ prüfen</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Checkbox.Root
                checked={confirmed}
                onCheckedChange={details => onConfirmedChange(Boolean(details.checked))}
              >
                <Checkbox.HiddenInput />
                <Checkbox.Control />
                <Checkbox.Label>
                  <Box>
                    <Text>Ich bestätige, dass die erfassten TOJ richtig und plausibel sind.</Text>
                    <Text>
                      Für diesen Tag wurden mehr als drei TOJ erfasst. Bitte prüfen und bestätigen
                      Sie die Eingabe vor dem Speichern.
                    </Text>
                  </Box>
                </Checkbox.Label>
              </Checkbox.Root>
            </Dialog.Body>

            {/* Both labels together are wider than the dialog, so the actions stack (SIB-1112). */}
            <Dialog.Footer flexDirection="column" alignItems="stretch">
              <Button
                colorPalette="blue"
                variant="subtle"
                disabled={!confirmed}
                onClick={onContinueSave}
              >
                Aktivität speichern
              </Button>

              <Button
                variant="solid"
                colorPalette="blue"
                disabled={!confirmed}
                onClick={onContinueSaveAndNew ?? onContinueSave}
              >
                Speichern & weitere Aktivität erfassen
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
